import React, { useEffect, useState } from 'react';
import { s } from '../Style';

const Autocomplete = ({ onChangeText = () => { }, style = {}, type, selected, onChange = () => { }, options = [], additionalOptions = [] }) => {

    let unifiedOptions = [ ...options, ...additionalOptions ];
    
    const [showingList, showList] = useState(false);
    const [predictions, setPredictions] = useState([]);
    const [value, setValue] = useState(type === "person"
        ? unifiedOptions.find(o => o.id === selected)?.phone[0] || ""
        : unifiedOptions.find(o => o.id === selected)?.name || "");
    const [secondaryValue, setSecondaryValue] = useState(type === "vendor" ? unifiedOptions.find(o => o.id === selected)?.address || "" : "");

    const handlePredictions = async e => {
        setValue(e.target.value);
        setSecondaryValue("");
        onChangeText(e.target.value);
        if (e.target.value.length) {
            let results;
            if (type !== "person") {
                results = unifiedOptions.filter(o => o.name?.toLowerCase().includes(e.target.value?.toLowerCase())).splice(0, 5);
            } else {
                results = unifiedOptions.filter(o => o.phone[0].includes(e.target.value)).splice(0, 5);
            }
            setPredictions(results);
        }
    }

    useEffect(() => {
        if (type !== "person") {
            setValue(unifiedOptions.find(o => o.id === selected)?.name || "");
        }else{
            setValue(unifiedOptions.find(o => o.id === selected)?.phone[0] || "");
        }
        if (type === "vendor") {
            setSecondaryValue(unifiedOptions.find(o => o.id === selected)?.address || "");
        }
    }, [selected]);

    return <div>
        <button
            onClick={() => {
                setSecondaryValue("");
                setValue("");
                onChange({ id: "", name: "" });
            }}
            style={{ border: 0, background: "transparent", color: "#888", cursor: "pointer", padding: 0, paddingRight: 4 }}
        >x</button>
        <input
            onClick={() => {
                setValue("");
                setSecondaryValue("");
            }}
            placeholder='Search'
            style={{ width: 160, fontSize: 14, paddingLeft: 4, border: "1px solid #ccc", borderRadius: 4, ...style.input }}
            value={value} onChange={handlePredictions} onFocus={() => showList(true)} onBlur={() => setTimeout(() => {
                if (!predictions.length) {
                    setValue(unifiedOptions.find(o => o.id === selected)?.name || "");
                    setSecondaryValue("");
                    if(type === "vendor") setSecondaryValue(unifiedOptions.find(o => o.id === selected)?.address || "");
                }
                showList(false)
            }, 200)} />
        {type === "vendor" && <span
            style={{
                fontSize: 12,
                color: "#888",
                display: "block",
                textTransform: "capitalize",
                marginTop: 2,
                textAlign: "right",
            }}
        >{secondaryValue}</span>}


        {showingList && <div style={{ position: "absolute", width: 200, border: "1px solid #ccc", backgroundColor: "white", zIndex: 100 }}>
            {/* <div onClick={() => {
                setValue("");
                onChange(false);
            }} style={{ padding: 4, cursor: "pointer" }}><i style={{fontSize:14}}>Null</i></div> */}
            {predictions.map((p, i) => <div key={i} onClick={() => {
                setValue(p.name);
                if (type === "vendor") setSecondaryValue(p.address);
                onChange(p);
                showList(false);
            }} style={{ padding: 4, cursor: "pointer" }}>
                <span
                    style={{
                        fontSize: 14,
                        fontWeight: "bold",
                        color: "#333",
                        textTransform: "capitalize",
                        display: "block"
                    }}
                >
                {type === "person" ? p.phone[0] : p.name}</span>
                {type === "vendor" && <span
                    style={{
                        fontSize: 12,
                        color: "#888",
                        textTransform: "capitalize",
                        display: "block"
                    }}
                >{p.address}</span>}
            </div>)}
        </div>
        }
    </div >;

}

export default Autocomplete;